import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Styles, Icon } from '@contently/toolkit';

const withDiffAdditions = `
  background: rgb(41, 162, 79, 0.5);
  background: linear-gradient(
    90deg,
    rgba(41, 162, 79, 1, 0.5) 0%,
    rgba(36, 179, 82, 1, 0.5) 100%
  );

  border-radius: 2px;
  text-decoration: underline;
`;

export const EditorWrapper = styled.div`
  border-radius: 3px;
  ${props =>
    props.readOnly || props.historyMode
      ? null
      : 'border: 1px solid #d4d4d4; box-shadow: 0 0 2px 1px #80808010;'}
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .ProseMirror {
    min-height: ${props => props.minHeight || '400px'};
    border-radius: 3px;
  }

  .added {
    ${props => (props.showDiff && props.historyMode ? withDiffAdditions : '')}
  }

  .removed {
    ${props => (props.showDiff && props.historyMode ? '' : 'display: none;')}
    text-decoration: line-through;
    background: rgb(233, 55, 55, 0.5);
    background: linear-gradient(90deg, rgb(233, 55, 55, 0.5) 0%, rgb(228, 92, 92, 0.5) 100%);
    border-radius: 3px;
  }

  .removed-img {
    ${props => (props.showDiff && props.historyMode ? '' : 'display: none;')}
    position: relative;
    background: linear-gradient(90deg, rgb(233, 55, 55, 0.5), rgb(228, 92, 92, 0.5));
    padding: 3px;
  }

  .tmpAnnotation {
    background: ${Styles.colors.yellow.primary};
  }

  .activeAnnotation {
    background-color: ${props => (props.historyMode ? 'none' : Styles.colors.orange.lightest)};
  }

  mark {
    background-color: transparent;
    border-bottom: ${props =>
      props.historyMode ? 'none' : `2px solid ${Styles.colors.orange.primary}`};
    cursor: ${props => (props.historyMode ? 'default' : 'pointer')};

    &:hover {
      background-color: ${props => (props.historyMode ? 'none' : Styles.colors.orange.lightest)};
    }
  }
`;

export const EditorPlaceholder = styled('div')`
  flex-grow: 1;

  .ProseMirror {
    position: relative;
    background: #fff;
    line-height: 1.2;
    outline: none;
  }

  .ProseMirror p {
    margin-bottom: 1em;
  }

  .ProseMirror {
    word-wrap: break-word;
    white-space: pre-wrap;
    -webkit-font-variant-ligatures: none;
    font-variant-ligatures: none;
  }

  .ProseMirror pre {
    white-space: pre-wrap;
  }

  .ProseMirror li {
    position: relative;
  }

  .ProseMirror-hideselection *::selection {
    background: transparent;
  }
  .ProseMirror-hideselection *::-moz-selection {
    background: transparent;
  }
  .ProseMirror-hideselection {
    caret-color: transparent;
  }

  .ProseMirror-selectednode {
    outline: 2px solid #8cf;
  }

  /* Make sure li selections wrap around markers */

  li.ProseMirror-selectednode {
    outline: none;
  }

  li.ProseMirror-selectednode:after {
    content: '';
    position: absolute;
    left: -32px;
    right: -2px;
    top: -2px;
    bottom: -2px;
    border: 2px solid #8cf;
    pointer-events: none;
  }

  @keyframes ProseMirror-cursor-blink {
    to {
      visibility: hidden;
    }
  }

  .ProseMirror-focused .ProseMirror-gapcursor {
    display: block;
  }

  .ProseMirror ul,
  .ProseMirror ol {
    padding-left: 30px;
  }

  .ProseMirror blockquote {
    padding-left: 1em;
    border-left: 3px solid #eee;
    margin-left: 0;
    margin-right: 0;
  }

  #editor,
  .editor {
    background: white;
    color: black;
    background-clip: padding-box;
    border-radius: 4px;
    border: 2px solid rgba(0, 0, 0, 0.2);
    padding: 5px 0;
    margin-bottom: 23px;
  }

  .ProseMirror p:first-of-type,
  .ProseMirror h1:first-of-type,
  .ProseMirror h2:first-of-type,
  .ProseMirror h3:first-of-type,
  .ProseMirror h4:first-of-type,
  .ProseMirror h5:first-of-type,
  .ProseMirror h6:first-of-type {
    margin-top: 10px;
  }

  .ProseMirror ul li p {
    margin: 0 !important;
  }
`;

const Wrapper = styled('p')`
  font-style: italic;
  font-family: "Chronicle Text G2 A", "Chronicle Text G2 B", Georgia, "Times New Roman", Times, serif;
  font-size: 18px;
  line-height: 28px;
  font-weight: 400;
  color: ${Styles.colors.grey.primary};
  margin: 0;
`;

export function NoContentMessage({ contentType = 'text' }) {
  return (
    <Wrapper>
      No {contentType} provided
    </Wrapper>
  );
}

export function LoadingMessage() {
  const StyledIcon = styled(Icon)`
    padding-right: 5px;
  `;

  const LoadingWrapper = styled(Wrapper)`
    padding-top: 10px;
  `;

  return (
    <LoadingWrapper>
      <StyledIcon type="spinner" spin="clockwise" />
      Content is on its way...
    </LoadingWrapper>
  );
}

NoContentMessage.defaultProps = {
  contentType: 'text'
};

NoContentMessage.propTypes = {
  contentType: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/baseComponents.jsx